import {Directive, ElementRef, HostListener, OnInit} from '@angular/core';

@Directive({
  selector: '[appNgSelectAriaControl]'
})
export class NgSelectAriaControlDirective implements OnInit {

  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      const hostElement: HTMLElement = this.el.nativeElement;

      const trigger = hostElement.querySelector('.ng-input');
      if (!trigger) return;

      const inputTrigger = hostElement.querySelector('.ng-input input');
      if (!inputTrigger) return;

      const ariaLabel = hostElement.getAttribute('aria-label');
      if (ariaLabel) {
        if (!trigger.getAttribute('aria-label')) {
          trigger.setAttribute('aria-label', ariaLabel);
        }
        if (!inputTrigger.getAttribute('aria-label')) {
          inputTrigger.setAttribute('aria-label', ariaLabel);
        }
      }

      inputTrigger.setAttribute('autocomplete', 'off');
    }, 0);
  }

  @HostListener('click')
  onClick() {
    setTimeout(() => {
      const hostElement: HTMLElement = this.el.nativeElement;

      const trigger = hostElement.querySelector('.ng-input');
      if (!trigger) return;

      const panels = document.querySelectorAll('.ng-dropdown-panel');

      if (!panels.length) return;

      let panel: HTMLElement | null = null;
      panels.forEach(p => {
        if (getComputedStyle(p).display !== 'none') {
          panel = p as HTMLElement;
        }
      });

      if (!panel) return;

      if (!panel.id) {
        panel.id = 'ng-select-panel-' + Math.random().toString(36).substring(2, 10);
      }

      const scrollHost = panel.querySelector('.scroll-host') as HTMLElement;
      if (scrollHost) {
        scrollHost.setAttribute('aria-hidden', 'true');
      }

      trigger.setAttribute('aria-controls', panel.id);
    }, 0);
  }
}
